export const MENSAGEM_TERMO_NAO_EXIGIDO = "Operadora não exige termo de adesão";

const STATUS_SEM_TERMO = "inexistente";

export const exigeTermoAdesao = (descricaoStatus?: string | null): boolean => {
  if (!descricaoStatus) {
    return false;
  }
  return descricaoStatus.trim().toLowerCase() !== STATUS_SEM_TERMO;
};
